import request from '@/utils/request'
//获取动态表
export function generateScheme(data) {
    return request({
        url: `/Common/GenerateScheme`,
        method: 'post',
        data
    })
}
//获取动态表
export function postList(data) {
    return request({
        url: `/MemberPost/GetPostList`,
        method: 'post',
        data
    })
}

//点赞动态
export function createPostLike(data) {
    return request({
        url: `/MemberPost/CreatePostLike`,
        method: 'post',
        data
    })
}

//取消点赞动态
export function cancelPostLike(data) {
    return request({
        url: `/MemberPost/CancelPostLike`,
        method: 'post',
        data
    })
}

//动态详情
export function postPicDetail(data) {
    return request({
        url: `/MemberPost/GetPostPictDetail`,
        method: 'post',
        data
    })
}

//关注头条号
export function followMember(data) {
    return request({
        url: `/Member/FollowMember`,
        method: 'post',
        data
    })
}


//取消关注头条号
export function unFollowMember(data) {
    return request({
        url: `/Member/UnFollowMember`,
        method: 'post',
        data
    })
}

//获取动态评论
export function postComment(data) {
    return request({
        url: `/MemberPost/GetPostComment`,
        method: 'post',
        data
    })
}

//点赞动态评论
export function postCommentLike(data) {
    return request({
        url: `/MemberPost/CreatePostCommentLike`,
        method: 'post',
        data
    })
}

//取消点赞动态评论
export function cancelCommentLike(data) {
    return request({
        url: `/MemberPost/CancelPostCommentLike`,
        method: 'post',
        data
    })
}

//发表评论
export function createPostComment(data) {
    return request({
        url: `/MemberPost/CreatePostComment`,
        method: 'post',
        data
    })
}


//知名品牌轮播
export function mobileAdverts(data) {
    return request({
        url: `/Home/GetMobileAdverts`,
        method: 'post',
        data
    })
}
//CheckMessage
export function checkMessage(data) {
    return request({
        url: `/MemberMsg/CheckMessage`,
        method: 'post',
        data
    })
}

//获取新闻资讯
export function homeArticleList(data) {
    return request({
        url: `/Home/GetHomeArticleList`,
        method: 'post',
        data
    })
}

//大咖推荐
export function recMemberList(data) {
    return request({
        url: `/MemberPost/GetRecMemberList`,
        method: 'post',
        data
    })
}

//大咖操作动态
export function recMemberOperationList(data) {
    return request({
        url: `/MemberPost/GetRecMemberOperationList`,
        method: 'post',
        data
    })
}


//大咖动态
export function recMemberPostMsg(data) {
    return request({
        url: `/MemberPost/GetRecMemberPostMsg`,
        method: 'post',
        data
    })
}

//大咖动态下
export function recMemberListByPost(data) {
    return request({
        url: `/MemberPost/GetRecMemberListByPost`,
        method: 'post',
        data
    })
}


export function exhibitionList(data) {
    return request({
        url: `/Home/GetExhibitionList`,
        method: 'post',
        data
    })
}


export function exhibitionCompanyList(data) {
    return request({
        url: `/Home/GetExhibitionCompanyList`,
        method: 'post',
        data
    })
}

//企业分享信息
export function visitShareInfo(data) {
    return request({
        url: `/Exhibition/GetVisitShareInfo`,
        method: 'post',
        data
    })
}

export function systemNewPost(data) {
    return request({
        url: `/MemberMsg/GetSystemNewPost`,
        method: 'post',
        data
    })
}

//获取酒店列表
export function getExhibitionHotelList(data) {
    return request({
        url: `/Exhibition/GetExhibitionHotelList`,
        method: 'post',
        data
    })
}


//获取搭建商列表
export function getExhibitionBuilderList(data) {
    return request({
        url: `/Exhibition/GetExhibitionBuilderList`,
        method: 'post',
        data
    })
}

//获取大会活动列表
export function getExhibitionActivityList(data) {
    return request({
        url: `/Exhibition/GetExhibitionActivityList`,
        method: 'post',
        data
    })
}

//获取名片列表
export function loginMemberBusinessContactList(data) {
    return request({
        url: `/BusinessContact/GetLoginMemberBusinessContactList`,
        method: 'post',
        data
    })
}

//获取名片夹列表
export function businessContactFoldersList(data) {
    return request({
        url: `/BusinessContact/GetBusinessContactFoldersList`,
        method: 'post',
        data
    })
}

//获取名片详情
export function memberBusinessContactInfo(data) {
    return request({
        url: `/BusinessContact/GetMemberBusinessContactInfo`,
        method: 'post',
        data
    })
}


//创建名片
export function createPersonalBusinessContact(data) {
    return request({
        url: `/BusinessContact/CreatePersonalBusinessContact`,
        method: 'post',
        data
    })
}

//修改名片
export function updateMemberBusinessContact(data) {
    return request({
        url: `/BusinessContact/UpdateMemberBusinessContact`,
        method: 'post',
        data
    })
}


//删除名片
export function deleteMemberBusinessContact(data) {
    return request({
        url: `/BusinessContact/DeleteMemberBusinessContact`,
        method: 'post',
        data
    })
}

//会员动态
export function memberPostList(data) {
    return request({
        url: `/MemberPost/GetMemberPostList`,
        method: 'post',
        data
    })
}

//删除名片夹名片
export function memberBusinessContactByFolders(data) {
    return request({
        url: `/BusinessContact/DeleteMemberBusinessContactByFolders`,
        method: 'post',
        data
    })
}

//保存名片
export function memberBusinessContactFolders(data) {
    return request({
        url: `/BusinessContact/SaveMemberBusinessContactFolders`,
        method: 'post',
        data
    })
}

//获取展位号
export function getExhibitionHallRecords(data) {
    return request({
        url: `/Exhibition/GetExhibitionHallRecords`,
        method: 'post',
        data
    })
}

//提交信息
export function addExhibitionCarRecord(data) {
    return request({
        url: `/Exhibition/AddExhibitionCarRecord`,
        method: 'post',
        data
    })
}

//获取车证
export function getExhibitionCarRecords(data) {
    return request({
        url: `/Exhibition/getExhibitionCarRecords`,
        method: 'post',
        data
    })
}